import { TFunction } from 'i18next';
import * as yup from 'yup';

import { settings } from '@krea/common/settings';
import { isValidEmail, ssnValidator } from '@krea/common/utils';

export const guarantorsFormSchema = (t: TFunction) =>
  yup.object().shape({
    guarantors: yup
      .array()
      .of(
        yup.object().shape({
          ssn: yup
            .string()
            .required('required')
            .test(
              'ssn',
              t('iaq.guarantor.personalNumberInvalid') as string,
              (value) => {
                return ssnValidator(value, settings.countryCode).isValid;
              },
            ),
          email: yup
            .string()
            .email(t('iaq.guarantor.emailInvalid') as string)
            .required('required')
            .test(
              'email',
              t('iaq.guarantor.emailInvalid') as string,
              (value) => {
                return isValidEmail(value);
              },
            ),
        }),
      )
      .required(),
  });

export type GuarantorFormSchema = yup.InferType<
  ReturnType<typeof guarantorsFormSchema>
>;
